import { formatDate, isValid, parseISO } from 'date-fns';
import { ITimeEntryDerivedActivity } from '../queries/TimeEntry';

export const DAY_FORMAT = 'yyyy-MM-dd';

export function isYmd(value: string) {
	if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
		return false;
	}
	const date = parseISO(value);
	return isValid(date) && formatDate(date, DAY_FORMAT) === value;
}

export function todayYmd(now = new Date()) {
	return formatDate(now, DAY_FORMAT);
}

export function formatDayShort(day: string) {
	return formatDate(parseISO(day), 'EEE, MMM d');
}

export function formatDayLong(day: string) {
	return formatDate(parseISO(day), 'EEEE, MMM d');
}

export function formatDateTime(iso?: string) {
	return iso ? formatDate(parseISO(iso), 'MMM d, h:mm a') : '—';
}

export function formatTime(iso?: string) {
	return iso ? formatDate(parseISO(iso), 'h:mm a') : '—';
}

export function formatDuration(totalMinutes: number) {
	const minutes = Math.max(0, Math.round(totalMinutes));
	return `${Math.floor(minutes / 60)}h ${String(minutes % 60).padStart(2, '0')}m`;
}

export function activityBounds(activity?: ITimeEntryDerivedActivity) {
	if (activity?.firstDialAt && activity.lastDialAt) {
		return { first: activity.firstDialAt, last: activity.lastDialAt };
	}
	// Days before the API timed dials only have call times.
	if (activity?.firstActivityAt && activity.lastActivityAt) {
		return { first: activity.firstActivityAt, last: activity.lastActivityAt };
	}
	return undefined;
}

export function activitySpanMinutes(activity?: ITimeEntryDerivedActivity) {
	const bounds = activityBounds(activity);
	if (!bounds) {
		return undefined;
	}
	return (parseISO(bounds.last).getTime() - parseISO(bounds.first).getTime()) / 60_000;
}

export function minutesOverActivitySpan(hours: number | undefined, activity?: ITimeEntryDerivedActivity) {
	const span = activitySpanMinutes(activity);
	if (hours === undefined || span === undefined) {
		return 0;
	}
	return Math.max(0, hours * 60 - span);
}
